import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnDestroy,
  AfterViewChecked,
  ViewChild,
  HostListener,
  ElementRef,
} from "@angular/core";
import { Filter } from "src/app/user-management/_model/filter.model";
import { DataService } from "src/app/dashboard/_services/data.service";
import { GlobalService } from "src/app/_services/global.service";
import { TranslateService } from "@ngx-translate/core";
import { DashboardService } from "src/app/reports/_services/dashboard.service";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { FlatTreeControl } from "@angular/cdk/tree";
import { TreeData } from "./TreeData";
import { SelectionModel } from "@angular/cdk/collections";
import { of as observableOf } from "rxjs";
import { Parent } from "./../../user-management/_model/parent.model";

declare var $: any;

export interface TreeNode {
  name: string;
  type: string;
  level: number;
  expandable: boolean;
}

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit, AfterViewChecked {
  treeControl: FlatTreeControl<TreeNode>;
  treeFlattener: MatTreeFlattener<TreeData, TreeNode>;
  dataSource: MatTreeFlatDataSource<TreeData, TreeNode>;
  checklistSelection = new SelectionModel<any>(true);

  selectedRoutesCheckBoxes = [];
  selectedRoutes = [];
  filterValues: Filter;
  roles: any = [];
  delegationRoles: any = [];
  delegationStatus: any = [];
  roleFilter: Array<any>;
  selectedGrades = [];
  selectedClasses = [];
  selectedGradesCheckBoxes = [];
  selectedClassesCheckBoxes = [];
  selectedRolesCheckBoxes = [];
  selectedGatesCheckBoxes = [];
  allGradesIsChecked: boolean;
  allClassesIsChecked: boolean;
  selectedGates = [];
  showedClasses = [];
  grades = [];
  mappedGrades = [];
  classes = [];
  gates = [];
  sounds = [];
  routes = [];
  registration: number = -1;
  activation: number = -1;
  @Input() listType;
  @ViewChild("tree") tree;
  prevListType: string;
  firstOpen;
  currLang;
  @ViewChild("filtermenu") filtermenu: ElementRef;

  @HostListener("click", ["$event.target"]) onClick(event) {
    const parent = this.filtermenu.nativeElement;
    if (!parent.contains(event)) {
      this.closeFilter();
    }
  }

  constructor(
    private translate: TranslateService,
    private globalService: GlobalService,
    private dashboardService: DashboardService,
    private dataService: DataService
  ) {
    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );

    this.treeControl = new FlatTreeControl<TreeNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.setRoles();
    // this.setSounds();
    this.setDelegationRoles();
    this.setDelegationStatus();

    this.filterValues = new Filter();
    this.roleFilter = [];
    this.filterValues.grades = [];
    this.filterValues.classes = [];
    this.filterValues.roles = [];
    this.filterValues.routes = [];
    this.filterValues.gates = [];
    this.filterValues.attendance = [];
    this.filterValues.sounds = [];
    this.filterValues.status = [];

    this.dataService.getAllGrades().subscribe((res) => {
      if (res !== null) {
        this.grades = res;
        this.grades.map((grade) => {
          this.classes.push(...grade.school_classes);
        });
        this.dataService.sentGrades(this.grades);
        this.dataService.sentClasses(this.classes);
      }
    });

    this.translate.get("init").subscribe((res) => {
      this.initializeFilter();
    });

    this.translate.onLangChange.subscribe((res) => {
      this.initializeFilter();
    });

    // this.dashboardService.getGrades().subscribe(res => {
    // if(res!=null){
    //   this.grades = res;
    //   this.mappedGrades = [
    //     {
    //       name: this.translate.instant('messages.filter.grades'),
    //       type: "grade_name",
    //       value: "grades22,",
    //       parent: "",
    //       disabled: false,
    //       children: this.grades.map(x => {
    //         return {
    //           name: x.name, type: 'grade_name', value: x.name, parent: 'grades', disabled: false,id:x.id, children:
    //             x.school_classes.map(y => ({
    //               name: y.name,
    //               type: 'class_name',
    //               value: y.name,
    //               parent: "classes",
    //               disabled: false,
    //               id:y.id
    //             }))
    //         }
    //       })
    //     }
    //   ]
    // }
    // this.dataSource.data= this.mappedGrades
    // })

    // this.dataService.getAllGates().subscribe((res: any) => {
    //   this.gates = res;
    // })
    this.dataService.getAllGates().subscribe((res: any) => {
      this.gates = res;
    });

    // this.dataService.getAllRoutes()?.subscribe((res: any) => {
    //   this.routes = res?.data;
    // });

    // the modal is closed ... reset the filter
    this.dataService.getFilterFlag().subscribe((res) => {
      if (res === "close") {
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.selectedGates = [];
        this.selectedRoutes = [];
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.roleFilter = [];
        this.filterValues = new Filter();
        this.filterValues.grades = [];
        this.filterValues.classes = [];
        this.filterValues.roles = [];
        this.filterValues.routes = [];
        this.filterValues.gates = [];
        // this.filterValues.registration = -1;
        this.selectedGradesCheckBoxes.map((selectedGradeCB) => {
          selectedGradeCB.source.checked = false;
        });

        this.selectedClassesCheckBoxes.map((selectedClassCB) => {
          selectedClassCB.source.checked = false;
        });
        this.selectedRolesCheckBoxes.map((selectedRoleCB) => {
          selectedRoleCB.source.checked = false;
        });
        this.selectedGatesCheckBoxes.map((selectedGateCB) => {
          selectedGateCB.source.checked = false;
        });
      }
    });

    this.dashboardService.getFilterFlag().subscribe((res) => {
      if (res === "close") {
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.selectedGates = [];
        this.selectedRoutes = [];
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.roleFilter = [];
        this.filterValues = new Filter();
        this.filterValues.grades = [];
        this.filterValues.classes = [];
        this.filterValues.roles = [];
        this.filterValues.routes = [];
        this.filterValues.gates = [];
        this.filterValues.registration = -1;
        this.selectedGradesCheckBoxes.map((selectedGradeCB) => {
          selectedGradeCB.source.checked = false;
        });

        this.selectedClassesCheckBoxes.map((selectedClassCB) => {
          selectedClassCB.source.checked = false;
        });
        this.selectedRolesCheckBoxes.map((selectedRoleCB) => {
          selectedRoleCB.source.checked = false;
        });
        this.selectedGatesCheckBoxes.map((selectedGateCB) => {
          selectedGateCB.source.checked = false;
        });
      }
    });

    this.dashboardService.getClearFilter().subscribe((res) => {
      if (res == true) {
        this.checklistSelection.clear();
      }
    });
  }

  ngAfterViewChecked() {
    // this.tree.treeControl.expand(this.treeControl.dataNodes[0]);
  }

  initializeFilter() {
    this.dataService.getGrades().subscribe((res) => {
      if (res != null) {
        this.grades = res;
        switch (this.listType) {
          case 'attendance-reports':
            this.mappedGrades = [
              {
                name: this.translate.instant("messages.filter.grades"),
                type: "grade_name",
                value: "grades22,",
                parent: "",
                disabled: false,
                children: this.grades.map((x) => {
                  return {
                    name: x.name,
                    type: "grade_name",
                    value: x.name,
                    parent: "grades",
                    disabled: false,
                    id: x.id,
                    children: x.school_classes.map((y) => ({
                      name: y.name,
                      type: "class_name",
                      value: y.name,
                      parent: "classes",
                      disabled: false,
                      id: y.id,
                    })),
                  };
                }),
              },
              {
                name: this.translate.instant("filter.attendance"),
                type: "Attendance",
                value: "",
                parent: "",
                disabled: false,
                children: [
                  {
                    name: this.translate.instant("filter.Absent"),
                    type: "Absent",
                    value: "absent",
                    parent: "Attendance",
                    disabled: false,
                  },
                  {
                    name: this.translate.instant("filter.Present"),
                    type: "Present",
                    value: "present",
                    parent: "Attendance",
                    disabled: false,
                  },
                  {
                    name: this.translate.instant("filter.Late"),
                    type: "Late",
                    value: "late",
                    parent: "Attendance",
                    disabled: false,
                  },
                ],
              },
            ]
            break;


            // this.sounds = [
            //   { name: this.translate.instant("filter.ai"), value: "ai" },
            //   { name: this.translate.instant("filter.recorded"), value: "recorded" },
            //   { name: this.translate.instant("filter.uploaded"), value: "uploaded" },
            // ];
           case 'name-sounds':
            this.mappedGrades = [
              {
                name: this.translate.instant("messages.filter.grades"),
                type: "grade_name",
                value: "grades22,",
                parent: "",
                disabled: false,
                children: this.grades.map((x) => {
                  return {
                    name: x.name,
                    type: "grade_name",
                    value: x.name,
                    parent: "grades",
                    disabled: false,
                    id: x.id,
                    children: x.school_classes.map((y) => ({
                      name: y.name,
                      type: "class_name",
                      value: y.name,
                      parent: "classes",
                      disabled: false,
                      id: y.id,
                    })),
                  };
                }),
              },
              {
                name: this.translate.instant("filter.sounds"),
                type: "sounds",
                value: "",
                parent: "",
                disabled: false,
                children: [
                  {
                    name: this.translate.instant("filter.ai"),
                    type: "Ai",
                    value: "ai",
                    parent: "sounds",
                    disabled: false,
                  },
                  {
                    name: this.translate.instant("filter.recorded"),
                    type: "Recorded",
                    value: "recorded",
                    parent: "sounds",
                    disabled: false,
                  },
                  {
                    name: this.translate.instant("filter.uploaded"),
                    type: "Uploaded",
                    value: "uploaded",
                    parent: "sounds",
                    disabled: false,
                  },
                ],
              },
            ]
            break;
          default:
            break;
        }


      }
      this.dataSource.data = this.mappedGrades;
    });
  }
  setRoles() {
    this.translate.get("init").subscribe((res) => {
      this.roles = [
        {
          name: this.translate.instant("filter.school-admin"),
          value: "school_admin",
        },
        { name: this.translate.instant("filter.teacher"), value: "teacher" },
        {
          name: this.translate.instant("filter.supervisor"),
          value: "supervisor",
        },
        { name: this.translate.instant("filter.security"), value: "security" },
        { name: this.translate.instant("filter.shared-gate"), value: "shared_gate_scanner" },
        {
          name: this.translate.instant("filter.gate"),
          value: "gate",
        },
        { name: this.translate.instant("filter.manager"), value: "manager" },
        {
          name: this.translate.instant("filter.cafeteria"),
          value: "cafeteria",
        },
      ];
    });
    this.translate.onLangChange.subscribe((res) => {
      for (let i = 0; i < this.roles.length; i++) {
        this.roles[0].name = this.translate.instant("filter.school-admin");
        this.roles[1].name = this.translate.instant("filter.teacher");
        this.roles[2].name = this.translate.instant("filter.supervisor");
        this.roles[3].name = this.translate.instant("filter.security");
        this.roles[4].name = this.translate.instant("filter.shared-gate");
        this.roles[5].name = this.translate.instant("filter.gate");
        this.roles[6].name = this.translate.instant("filter.manager");
      }
    });

    // this.translate.onLangChange.subscribe(res => {
    //   this.roles = [
    //     { name: this.translate.instant('filter.school-admin'), value: 'school_admin' },
    //     { name: this.translate.instant('filter.teacher'), value: 'teacher' },
    //     { name: this.translate.instant('filter.supervisor'), value: 'supervisor' },
    //     { name: this.translate.instant('filter.security'), value: 'security' }]
    // });
  }

  setDelegationRoles() {
    this.translate.get("init").subscribe((res) => {
      this.delegationRoles = [
        {
          name: this.translate.instant("filter.school-admin"),
          value: "school_admin",
        },
        { name: this.translate.instant("filter.teacher"), value: "teacher" },
        {
          name: this.translate.instant("filter.supervisor"),
          value: "supervisor",
        },
        // { name: this.translate.instant('filter.security'), value: 'security' }
      ];
    });
    this.translate.onLangChange.subscribe((res) => {
      for (let i = 0; i < this.delegationRoles.length; i++) {
        this.delegationRoles[0].name = this.translate.instant(
          "filter.school-admin"
        );
        this.delegationRoles[1].name = this.translate.instant("filter.teacher");
        this.delegationRoles[2].name =
          this.translate.instant("filter.supervisor");
        // this.delegationRoles[3].name=this.translate.instant('filter.security');
      }
    });
  }
  setDelegationStatus() {
    this.translate.get("init").subscribe((res) => {
      this.delegationStatus = [
        {
          name: this.translate.instant("filter.delegation.accepted"),
          value: "accepted",
        },
        {
          name: this.translate.instant("filter.delegation.pending"),
          value: "pending",
        },
        {
          name: this.translate.instant("filter.delegation.rejected"),
          value: "rejected",
        },
      ];
    });
    this.translate.onLangChange.subscribe((res) => {
      for (let i = 0; i < this.delegationRoles.length; i++) {
        this.delegationStatus[0].name = this.translate.instant(
          "filter.delegation.accepted"
        );
        this.delegationStatus[1].name = this.translate.instant(
          "filter.delegation.pending"
        );
        this.delegationStatus[2].name = this.translate.instant(
          "filter.delegation.rejected"
        );
      }
    });
  }

  // setSounds() {
  //   this.translate.get("init").subscribe((res) => {
  //     this.sounds = [
  //       { name: this.translate.instant("filter.ai"), value: "ai" },
  //       { name: this.translate.instant("filter.recorded"), value: "recorded" },
  //       { name: this.translate.instant("filter.uploaded"), value: "uploaded" },
  //     ];
  //   });
  //   this.translate.onLangChange.subscribe((res) => {
  //     for (let i = 0; i < this.sounds.length; i++) {
  //       this.sounds[0].name = this.translate.instant("filter.ai");
  //       this.sounds[1].name = this.translate.instant("filter.recorded");
  //       this.sounds[2].name = this.translate.instant("filter.uploaded");
  //     }
  //   });
  // }

  closeFilter() {
    this.dataService.toggleFilterStatus(false);
    this.dashboardService.toggleFilterStatus(false);
  }

  setRouteFilter(event) {
    if (event.checked) {
      this.selectedRoutesCheckBoxes.push(event);
      this.selectedRoutes.push(event.source.value);
      this.filterValues.routes.push(event.source.value.route_name);
    } else {
      this.selectedRoutesCheckBoxes = this.selectedRoutesCheckBoxes.filter(
        (selectedRouteCheckBox) =>
          selectedRouteCheckBox.source.value.id !== event.source.value.id
      );
      this.selectedRoutes = this.selectedRoutes.filter(
        (selectedRoute) => selectedRoute.id !== event.source.value.id
      );
      this.filterValues.routes = this.filterValues.routes.filter(
        (route) => route !== event.source.value.route_name
      );
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  setRoleFilter(event) {
    if (event.checked) {
      this.roleFilter.push(event.source.value);
      this.selectedRolesCheckBoxes.push(event);
      this.filterValues.roles.push(event.source.value);
      this.roleFilter.forEach((element) => {
        for (let i = 0; i < this.roles.length; i++) {
          if (this.roles[i].value == element) {
            this.roles[i]["isSelected"] = true;
          }
        }
      });
    } else {
      this.roleFilter = this.roleFilter.filter(
        (role) => role !== event.source.value
      );
      this.selectedRolesCheckBoxes.filter(
        (selectedRoleCheckBox) =>
          selectedRoleCheckBox.source.value.id !== event.source.value.id
      );
      this.filterValues.roles = this.filterValues.roles.filter(
        (role) => role !== event.source.value
      );
      switch (event.source.value) {
        case "teacher":
          this.selectedGrades = [];
          this.selectedClasses = [];
          this.selectedClassesCheckBoxes = [];
          this.selectedGradesCheckBoxes = [];
          this.allGradesIsChecked = false;
          this.allClassesIsChecked = false;
          this.filterValues.grades = [];
          this.filterValues.classes = [];
          break;
        case "security":
          this.selectedGates = [];
          this.selectedGatesCheckBoxes = [];
          this.filterValues.gates = [];
          break;
        case "supervisor":
          this.selectedGrades = [];
          this.allGradesIsChecked = false;
          this.selectedGradesCheckBoxes = [];
          this.filterValues.grades = [];
          break;
        default:
          break;
      }
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // getRoleName(roleName: string) {
  //   let newRoleName;
  //   newRoleName = roleName.includes('_') ? roleName.replace("_", " ") : roleName;
  //   return newRoleName;
  // }

  checkAll(filterBy: string) {
    // user select all grades by default we will select all classes

    if (filterBy === "grade") {
      this.selectedGrades =
        this.allGradesIsChecked == true ? [...this.grades] : [];
      this.showedClasses =
        this.allGradesIsChecked == true
          ? JSON.parse(JSON.stringify(this.classes))
          : [];
      this.selectedClasses = [];
      if (this.selectedGrades.length > 0) {
        this.selectedGrades.map((selectedGrade) => {
          this.filterValues.grades.push(selectedGrade.id);
        });
        this.grades.map((grade) => {
          grade["isSelected"] = true;
        });
      } else {
        // user deselect all grades so by default deslect all classes
        this.allGradesIsChecked = false;
        this.allClassesIsChecked = false;
        this.selectedGrades = [];
        this.selectedClasses = [];
        this.selectedGradesCheckBoxes = [];
        this.selectedClassesCheckBoxes = [];
        this.filterValues.grades = [];
        this.filterValues.classes = [];
      }
    }
    // user selected all classes
    else {
      this.selectedClasses =
        this.allClassesIsChecked == true ? this.showedClasses : [];
      if (this.selectedClasses.length > 0) {
        this.selectedClasses.map((selectedClass) => {
          this.filterValues.classes.push(selectedClass.id);
        });
        this.showedClasses.map((showedClass) => {
          showedClass["isSelected"] = true;
        });
      } else {
        this.filterValues.classes = [];
      }
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // check or uncheck from filter
  // grades and classe filter
  filterHandler(filterBy: string, event) {
    // if user filtered by grades
    switch (filterBy) {
      case "grade":
        if (event.checked) {
          this.allClassesIsChecked =
            this.allClassesIsChecked == true ? false : false;
          this.selectedGrades.push(event.source.value);
          this.selectedGradesCheckBoxes.push(event);
          this.filterValues.grades.push(event.source.value.id);
        } else {
          this.selectedGrades = this.selectedGrades.filter(
            (selectedGrade) => selectedGrade.id !== event.source.value.id
          );
          if (this.selectedGrades.length == 0) {
            this.allGradesIsChecked = false;
          }
          this.selectedGradesCheckBoxes = this.selectedGradesCheckBoxes.filter(
            (selectedGradeCb) =>
              selectedGradeCb.source.value.id !== event.source.value.id
          );
          this.selectedClasses = this.selectedClasses.filter(
            (selectedClass) => selectedClass.grade_id !== event.source.value.id
          );
          this.selectedClassesCheckBoxes =
            this.selectedClassesCheckBoxes.filter(
              (selectedClassCheckBox) =>
                selectedClassCheckBox.source.value.grade_id !==
                event.source.value.id
            );
          this.filterValues.grades = this.filterValues.grades.filter(
            (grade) => grade !== event.source.value.id
          );
          this.filterValues.classes = [];
          this.selectedClasses.map((selectedClass) => {
            this.filterValues.classes.push(selectedClass.id);
          });
        }
        this.updateClasses();
        break;
      case "class":
        if (event.checked) {
          this.selectedClasses.push(event.source.value);
          this.selectedClassesCheckBoxes.push(event);
          this.filterValues.classes.push(event.source.value.id);
        } else {
          this.selectedClasses = this.selectedClasses.filter(
            (selectedClass) => selectedClass.id !== event.source.value.id
          );
          if (this.selectedClasses.length == 0) {
            // the user unchecked all classes
            this.allClassesIsChecked = false;
          }
          this.selectedClassesCheckBoxes =
            this.selectedClassesCheckBoxes.filter(
              (selectedClassCb) =>
                selectedClassCb.source.value.id !== event.source.value.id
            );
          this.filterValues.classes = this.filterValues.classes.filter(
            (oneClass) => oneClass !== event.source.value.id
          );
        }
        break;
      // case "sound":
      //   if (event.checked) {
      //     this.filterValues.sounds.push(event.source.value.value);
      //   } else {
      //     this.filterValues.sounds = this.filterValues.sounds.filter(
      //       (sound) => sound !== event.source.value.value
      //     );
      //   }
      //   break;
      case "role":
        if (event.checked) {
          this.filterValues.roles.push(event.source.value.value);
        } else {
          this.filterValues.roles = this.filterValues.roles.filter(
            (role) => role !== event.source.value.value
          );
        }
        break;
      case "status":
        if (event.checked) {
          this.filterValues.status.push(event.source.value.value);
        } else {
          this.filterValues.status = this.filterValues.status.filter(
            (status) => status !== event.source.value.value
          );
        }
        break;
    }
    this.dataService.setFilterValue(this.filterValues);
    this.dashboardService.setFilterValue(this.filterValues);
  }

  updateClasses() {
    // all classes in selected grade to be shown in filter list
    this.showedClasses = [];
    if (this.selectedGrades.length == 0) {
      this.selectedClasses = [];
      this.filterValues.classes = [];
    } else {
      this.selectedGrades.map((grade) => {
        this.showedClasses.push(
          ...JSON.parse(JSON.stringify(grade.school_classes))
        );
      });
      for (let i = 0; i < this.selectedClasses.length; i++) {
        if (this.selectedClasses[i].id === this.showedClasses[i].id) {
          this.showedClasses[i]["isSelected"] = true;
        }
      }
    }
  }

  // gates and routes in staff filters
  toggleRegAndActivationFilters(toggleBy: string, event) {
    if (event.checked) {
      this[toggleBy] = event.source.value;
      this.filterValues[toggleBy] = this[toggleBy];
    } else {
      // this code is used also when removed by chips filter
      this[toggleBy] = -1;
      this.filterValues[toggleBy] = this[toggleBy];
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  // refactor if routes names key changed to name only instedd of route_name
  setGateFilter(event) {
    if (event.checked) {
      this.selectedGatesCheckBoxes.push(event);
      this.selectedGates.push(event.source.value);
      this.filterValues.gates.push(event.source.value.id);
    } else {
      this.selectedGatesCheckBoxes = this.selectedGatesCheckBoxes.filter(
        (selectedGateCheckBox) =>
          selectedGateCheckBox.source.value.id !== event.source.value.id
      );
      this.selectedGates = this.selectedGates.filter(
        (selectedGate) => selectedGate.id !== event.source.value.id
      );
      this.filterValues.gates = this.filterValues.gates.filter(
        (gate) => gate !== event.source.value.id
      );
    }
    this.dataService.setFilterValue(this.filterValues);
  }

  transformer(node: TreeData, level: number) {
    return {
      name: node.name,
      id: node.id,
      type: node.type,
      parent: node.parent,
      value: node.value,
      role: node.role || null,
      level: level,
      disabled: node.disabled,
      expandable: !!node.children,
    };
  }

  /** Get the level of the node */
  getLevel(node: TreeNode) {
    return node.level;
  }

  /** Return whether the node is expanded or not. */
  isExpandable(node: TreeNode) {
    return node.expandable;
  }

  /** Get the children for the node. */
  getChildren(node: TreeData) {
    return observableOf(node.children);
  }

  /** Get whether the node has children or not. */
  hasChild(index: number, node: TreeNode) {
    return node.expandable;
  }

  checkAllParentsSelection(node: any): void {
    let parent: any | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }
  checkRootNodeSelection(node: any): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: any): any | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  descendantsPartiallySelected(node: any): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: any): boolean {
    const descendants = this.treeControl.getDescendants(node);

    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );

    return descAllSelected && descendants.length != 0;
  }

  // uncheckNodes(type) {
  //   this.treeControl.dataNodes.filter(node => node.type == type).forEach(node => {
  //     this.checklistSelection.isSelected(node) ? this.checklistSelection.deselect(node) : console.log('')
  //     console.log(this.checklistSelection);

  //   })
  //   if(this.filterValues.attendance.includes('absent')){
  //     console.log("yahoooo");

  //     this.filterValues.attendance = this.filterValues.attendance.filter(e => e !== 'absent');
  //   }
  // }

  // Tree Filter
  // level 1 node
  todoItemSelectionToggle(node: any): void {
    // to toggle the selection of the node
    this.checklistSelection.toggle(node);
    // to get the descendants of the node , in this case level 2 nodes
    const descendants = this.treeControl.getDescendants(node);
    // chech if this level 1 node is selected then select all level 2 desendants nodes else deselect them
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
    // switch(node.name) {
    //   case "Attendance":
    //     this.filterValues.absent=true;
    //     this.filterValues.present=true;
    //     console.log(this.filterValues);

    //     break;
    //   case "Grades":

    //     break;
    //   }
    // filter the values in the selected array , to get the parent if it's grades then added to the filterValues grades array , if it's classes then added to the filterValues classes array
    //  this.filterValues.grades=this.checklistSelection.selected.filter(selected=> selected.parent=='grades');
    //  grades removed as it made conflict with backends
    this.filterValues.classes = this.checklistSelection.selected.filter(
      (selected) => selected.parent == "classes"
    );
    
    // to select or deselect all node children when selecting or deselecting sound node.
    this.filterValues.sounds = this.checklistSelection.selected.filter(
      (selected) => selected.parent == "sounds").map(sound=> sound.value);

    // to select or deselect all node children when selecting or deselecting Attendance node.
      this.filterValues.attendance = this.checklistSelection.selected.filter(
        (selected) => selected.parent == "Attendance").map(attendance=> attendance.value);

    // send the filterValues to the dashboard service
    this.dashboardService.setFilterValue(this.filterValues);
    this.dataService.setFilterValue(this.filterValues);

  }
  // level 2 node
  todoLeafItemSelectionToggle(node: any): void {
    // to toggle the selection of the node
    this.checklistSelection.toggle(node);
    // to get the parents of the node , in this case level 1 nodes
    this.checkAllParentsSelection(node);
    switch (node.name) {
      case this.translate.instant("filter.Absent"):
        if (this.filterValues.attendance.includes("absent")) {
          let temp = this.filterValues.attendance.filter((e) => e !== "absent");
          this.filterValues.attendance = temp;
        } else {
          this.filterValues.attendance.push("absent");
        }
        // this.filterValues.attendance=['absent'];
        break;
      case this.translate.instant("filter.Present"):
        if (this.filterValues.attendance.includes("present")) {
          let temp = this.filterValues.attendance.filter(
            (e) => e !== "present"
          );
          this.filterValues.attendance = temp;
        } else {
          this.filterValues.attendance.push("present");
        }
        // this.filterValues.attendance.push('present');
        break;
      case this.translate.instant("filter.Late"):
        if (this.filterValues.attendance.includes("late")) {
          let temp = this.filterValues.attendance.filter((e) => e !== "late");
          this.filterValues.attendance = temp;
        } else {
          this.filterValues.attendance.push("late");
        }
        // this.filterValues.attendance.push('late');
        break;

        case this.translate.instant("filter.ai"):
        if (this.filterValues.sounds.includes("ai")) {
          let temp = this.filterValues.sounds.filter((e) => e !== "ai");
          this.filterValues.sounds = temp;
        } else {
          this.filterValues.sounds.push("ai");
        }
        break;

        case this.translate.instant("filter.recorded"):
          if (this.filterValues.sounds.includes("recorded")) {
            let temp = this.filterValues.sounds.filter((e) => e !== "recorded");
            this.filterValues.sounds = temp;
          } else {
            this.filterValues.sounds.push("recorded");
          }
          break;

          case this.translate.instant("filter.uploaded"):
          if (this.filterValues.sounds.includes("uploaded")) {
            let temp = this.filterValues.sounds.filter((e) => e !== "uploaded");
            this.filterValues.sounds = temp;
          } else {
            this.filterValues.sounds.push("uploaded");
          }
          break;
    }
    // filter the values in the selected array , to get the parent if it's grades then added to the filterValues grades array , if it's classes then added to the filterValues classes array
    // this.filterValues.grades=this.checklistSelection.selected.filter(selected=> selected.parent=='grades');
    this.filterValues.classes = this.checklistSelection.selected.filter(
      (selected) => selected.parent == "classes"
    );
    // send the filterValues to the dashboard service
    this.dashboardService.setFilterValue(this.filterValues);

    this.dataService.setFilterValue(this.filterValues);
  }
}
